import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PercentageOutlinedSvg from "@ant-design/icons-svg/es/asn/PercentageOutlined";
import AntdIcon from '../components/AntdIcon';
var PercentageOutlined = function PercentageOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: PercentageOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(PercentageOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'PercentageOutlined';
}
export default RefIcon;